import React from 'react'
import utils from "../../modules/utils";
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import './header.css';
/* Flow */
import { goBack } from '../../flow/flow';

const mapDispatchToProps = dispatch => {
  return {}
}

const mapStateToProps = (state) => {
  return {
    prodotto: state.prodotto,
    excluded: state.cap_excluded
  }
}

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      'backVisible': false,
      'modal_visible': false
    };
    this.goToMainSite = this.goToMainSite.bind(this);
    this.hideBanner = this.hideBanner.bind(this);
    this.logoAction = this.logoAction.bind(this);
  }

  goToMainSite(e) {
    e.preventDefault();
    //window.location.href = utils.getFaPath();
  }

  goCompass() {
    window.location.href = "https://compass.it";
  }

  hideBanner(e) {
    e.preventDefault();
    this.setState({
      'modal_visible': false
    });
  }

  logoAction() {
    if (window.location.pathname == utils.getFaPath() + "/riepilogo-modifica-appuntamento") {
      utils.goTo("/fissa-appuntamento");
    } else if (window.location.pathname == utils.getFaPath() + "/typ_RICHIAMAMI") {
      this.goCompass();
    }
  }

  render() {
    const { location } = this.props;

    let classeLogo = '';
    let isC5 = false;
    if ((window.location.hostname.indexOf("quinto")!=-1 && this.props.prodotto !== 1) || this.props.prodotto == 3) {
      isC5 = true;
    }

    let backBtn = "";
    let ics = "";
    if (
      location.pathname == utils.getFaPath()
      || location.pathname == utils.getFaPath() + "/scegli-dove"
    ) {
      ics = (
        <a href="#" id="go_compass" onClick={this.goToMainSite} aria-label="torna al sito compass">
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M11.3388 14.8744L2.5 23.7132L6.03553 27.2487L14.8744 18.4099L23.7132 27.2487L27.2487 23.7132L18.4099 14.8744L27.2487 6.03553L23.7132 2.5L14.8744 11.3388L6.03553 2.5L2.5 6.03553L11.3388 14.8744Z" fill="#282828" />
          </svg>
        </a>
      );
    }
    const global_state = utils.getState();
    const isC5fromParams = (global_state.prodotto == 3 && location.pathname == utils.getFaPath() + "/codice-fiscale" && global_state.product_from_param) || (location.pathname == utils.getFaPath() + "/scegli-luogo" && window.location.hostname.indexOf("quinto") != -1)

    if (
      global_state.tipo_appuntamento != ""
      && location.pathname != utils.getFaPath()
      && location.pathname != utils.getFaPath() + "/thank-you-page"
      && location.pathname != utils.getFaPath() + "/thank-you-page-CQ"
      && location.pathname != utils.getFaPath() + "/thank-you-page-AUP"
      && location.pathname != utils.getFaPath() + "/riepilogo-modifica-appuntamento"
      && location.pathname != utils.getFaPath() + "/conferma-modifica-appuntamento"
      && !isC5fromParams
    ) {
      backBtn = (
        <div id="go_back" onClick={goBack}>
          <svg width="18" height="26" viewBox="0 0 18 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.6989 12.6641L17.2831 21.5091L13.8661 25.0332L0.466309 12.6669L13.8638 0.283203L17.2837 3.80461L7.6989 12.6641Z" fill="#282828" />
          </svg>
          <span title={utils.getBackText()}>{(utils.getBackText() && utils.getBackText().length > 25) ? (utils.getBackText().substr(0, 25) + '...') : utils.getBackText()}</span>
        </div>
      );
    }

    if (location.pathname == utils.getFaPath() + "/typ_RICHIAMAMI") {
      classeLogo = 'logoManinato';
      backBtn = (
        <div id="go_back" onClick={this.goCompass}>
          <svg width="18" height="26" viewBox="0 0 18 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.6989 12.6641L17.2831 21.5091L13.8661 25.0332L0.466309 12.6669L13.8638 0.283203L17.2837 3.80461L7.6989 12.6641Z" fill="#282828" />
          </svg>
          <span title={utils.getBackText()}>{(utils.getBackText() && utils.getBackText().length > 25) ? (utils.getBackText().substr(0, 25) + '...') : utils.getBackText()}</span>
        </div>
      );
    }

    return (
      <div className="header-container">
        <header className={classeLogo}>
          {backBtn}
          {(!isC5 || this.props.excluded) ? <img src="./img/logo-compass-banca.png" alt="Logo Compass Banca" onClick={this.logoAction} /> : <img src="./img/logo-compass-quinto-nero.png" alt="Logo Compass Quinto" className="c5logo" onClick={this.logoAction} />}
          {ics}
        </header>
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header))


// WEBPACK FOOTER //
// ./src/components/shared/header.js